(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["helpcenter-search"] && !Shopify.designMode) return;
  try {
    const initializeHelpcenterSearch = () => {
    document.querySelectorAll('[data-helpcenter-search]').forEach((root) => {
      if (root.dataset.searchReady === 'true') return;
      root.dataset.searchReady = 'true';

      const input = root.querySelector('[data-helpcenter-input]');
      const panel = root.querySelector('[data-helpcenter-results]');
      const resultList = root.querySelector('[data-helpcenter-result-list]');
      const noResults = root.querySelector('[data-helpcenter-no-results]');
      const results = Array.from(root.querySelectorAll('[data-helpcenter-result]')).map((element, index) => ({
        element,
        index,
        title: element.dataset.searchTitle,
        summary: element.dataset.searchSummary,
        category: element.dataset.searchCategory,
        content: element.dataset.searchContent,
      }));

      const normalize = (value = '') => value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      results.forEach((result) => {
        result.title = normalize(result.title);
        result.summary = normalize(result.summary);
        result.category = normalize(result.category);
        result.content = normalize(result.content);
        result.searchable = `${result.title} ${result.summary} ${result.category} ${result.content}`;
      });

      const includesAll = (value, tokens) => tokens.every((token) => value.includes(token));

      const getScore = (result, query, tokens) => {
        if (!includesAll(result.searchable, tokens)) return -1;

        let score = 1;

        if (result.title === query) score += 1200;
        else if (result.title.startsWith(query)) score += 900;
        else if (result.title.includes(query)) score += 700;
        if (includesAll(result.title, tokens)) score += 350;

        if (result.summary.includes(query)) score += 280;
        else if (includesAll(result.summary, tokens)) score += 170;

        if (result.category.includes(query)) score += 180;
        else if (includesAll(result.category, tokens)) score += 100;

        if (result.content.includes(query)) score += 90;
        else if (includesAll(result.content, tokens)) score += 45;

        return score;
      };

      const closeResults = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const updateResults = () => {
        const query = normalize(input.value);
        const canSearch = query.length >= 2;
        const tokens = query.split(' ').filter(Boolean);

        results.forEach((result) => {
          result.element.hidden = true;
        });

        const matches = canSearch
          ? results
            .map((result) => ({ result, score: getScore(result, query, tokens) }))
            .filter((match) => match.score >= 0)
            .sort((first, second) => second.score - first.score || first.result.index - second.result.index)
          : [];

        matches.forEach((match) => {
          match.result.element.hidden = false;
          resultList.appendChild(match.result.element);
        });

        noResults.hidden = !canSearch || matches.length > 0;
        panel.hidden = !canSearch;
        input.setAttribute('aria-expanded', canSearch ? 'true' : 'false');
      };

      input.addEventListener('input', updateResults);
      input.addEventListener('focus', updateResults);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeResults();
      });
      input.form.addEventListener('submit', (event) => {
        event.preventDefault();
        updateResults();
      });
      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closeResults();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHelpcenterSearch, { once: true });
  } else {
    initializeHelpcenterSearch();
  }
  } catch(e) { console.error(e); }
})();

})();
